export enum UserCashBackStatus {
  PENDING = 'PENDING',

  APPROVED = 'APPROVED',

  REJECTED = 'REJECTED',
}
